export const media = {
  dots: '/static/images/home-valuation/desktop-dots.svg',
  tick: '/static/images/home-valuation/tick.svg',
  cmaTable: '/static/images/home-valuation/cma-table.webp',
  cmaTableMobile: '/static/images/home-valuation/cma-table-mobile.webp',
};
